// src/Games/GamesHooks/useBimaGameState.js
import { useState, useCallback } from 'react';

export const INITIAL_STATE = {
  screen: 'intro',
  tourMode: null,
  walkthroughStep: 0,
  persona: null,
  age: 30,
  maritalStatus: null,
  children: 0,
  dependants: null,
  occupation: null,
  income: null,
  spouseIncome: null,
  health: null,
  discSmoking: null,
  discCondition: null,
  discHazard: null,
  readExclusions: null,
  discSource: null,
  amlIDProvided: null,
  product: null,
  sumAssured: null,
  riderCritical: false,
  riderDisability: false,
  monthlyPremium: 0,
  agentSeen: false,
  agentChoice: null,
  yearIdx: 0,
  totalPremiumsPaid: 0,
  policyLapsed: false,
  lapsedAtYear: null,
  policyVoid: false,
  voidReason: null,
  cashValue: 0,
  parallelInvestment: 0,
  mmfBalance: 0,
  mmfYearlyContribs: [],
  surrenderedAmount: 0,
  surrenderedAtYear: null,
  boughtNewPolicy: false,
  newPolicyAge: null,
  newPolicyPremium: 0,
  newPolicySumAssured: 0,
  amlFlagged: false,
  amlOutcome: null,
  iraComplaintFiled: false,
  iraOutcome: null,
  claimEventOccurred: false,
  claimOutcome: null,
  claimAmount: 0,
  claimEventVariant: null,
  currentEvent: null,
  log: [],
  pendingStory: null,
};

export function useBimaGameState() {
  const [state, setState] = useState({ ...INITIAL_STATE });

  // Merge partial updates
  const update = useCallback((patch) => {
    setState((prev) => ({ ...prev, ...patch }));
  }, []);

  // Apply a choice result: the choice.apply() function mutates a draft copy,
  // then we merge the mutated copy back into React state.
  const applyChoice = useCallback((applyFn) => {
    setState((prev) => {
      // Deep-copy enough of the state for mutation
      const draft = {
        ...prev,
        mmfYearlyContribs: [...prev.mmfYearlyContribs],
        log: [...prev.log],
      };
      const result = applyFn(draft);
      // result: { story, tone, lapsed? }
      return {
        ...draft,
        pendingStory: {
          story: result.story,
          tone: result.tone || '',
          nextScreen: result.lapsed ? 'lapse_decision' : 'advance_year',
        },
      };
    });
  }, []);

  const reset = useCallback(() => {
    setState({ ...INITIAL_STATE });
  }, []);

  return { state, update, applyChoice, reset };
}